import { Box, Paper } from "@mui/material";
import { default as React, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from "xlsx";
import { customDateConvert } from "../../../components/Common/Utils/Utils";
import { useAuthContext } from "../../../context/AuthProvider";
import useApi from "../../../service/api.service";
import TableSkeleton from "../../operator/Components/TableSkeleton";
import ColumnChart from "./ColumnChart";
import BoxPlot from "./BoxPlot";

function RightContainer({ loading, data }) {
  return (
    <div style={{ height: "100%" }}>
      <Box
        sx={{
          // borderTop: "2px solid #DEDEDE",
          height: `calc(100%-90px)`,
          // width: "102%",
          // overflow: "auto",
          display: "flex",
          gap: "20px",
        }}
      >
        {loading ? (
          <TableSkeleton width="300" />
        ) : (
          <>
            <Paper
              sx={{
                width: "70%",
                //   padding: "10px",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                boxSizing: "border-box",
                fontWeight: 500,
                color: "#404040",
                boxShadow: "none",
                border: "1px solid #E4E4E4",
                overflowY: "auto",
              }}
            >
              <ColumnChart
                actual={data?.distributionData?.scrappedOneValues || []}
                predicted={data?.distributionData?.scrappedZeroValues || []}
                categories={data?.distributionData?.categories || []}
                factorName={data?.distributionData?.factorName?.[0] || ""}
              />
            </Paper>
            <Paper
              sx={{
                width: "30%",
                //   padding: "10px",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                boxSizing: "border-box",
                fontWeight: 500,
                color: "#404040",
                boxShadow: "none",
                border: "1px solid #E4E4E4",
                overflowY: "auto",
              }}
            >
              <BoxPlot
                actual={data?.boxData?.values || []}
                categories={data?.boxData?.categories || []}
                TheoreticalMean={data?.boxData?.TheoreticalMean || []}
                factorName={data?.boxData?.categories?.[0] || ""}
              />
            </Paper>
          </>
        )}
      </Box>
      <Toaster />
    </div>
  );
}

export default RightContainer;
